/**
 * ErrorState.tsx
 * État d'erreur plein écran réutilisable (projet introuvable, accès refusé,
 * erreur réseau…), avec actions (retour, réessayer, créer…).
 */
import React from 'react';

export interface ErrorStateAction {
  label: string;
  onClick: () => void;
  primary?: boolean;
}

export interface ErrorStateProps {
  icon?: string;
  title: string;
  message?: string;
  actions?: ErrorStateAction[];
  /** Plein écran (overlay) ou inline dans un conteneur. */
  fullscreen?: boolean;
}

export function ErrorState({
  icon = '⚠️',
  title,
  message,
  actions = [],
  fullscreen = true,
}: ErrorStateProps): React.ReactElement {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: fullscreen ? '100vh' : '100%',
        width: fullscreen ? '100vw' : '100%',
        background: 'var(--color-bg-secondary, #14131f)',
        padding: 24,
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 420 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
        <h2
          style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 8,
            color: 'var(--color-text-primary, #fff)',
          }}
        >
          {title}
        </h2>
        {message && (
          <p
            style={{
              fontSize: 14,
              color: 'var(--color-text-secondary, #9a9aa8)',
              marginBottom: 24,
              lineHeight: 1.5,
            }}
          >
            {message}
          </p>
        )}
        {actions.length > 0 && (
          <div style={{ display: 'flex', gap: 10, justifyContent: 'center', flexWrap: 'wrap' }}>
            {actions.map((a, i) => (
              <button
                key={i}
                onClick={a.onClick}
                style={{
                  padding: '9px 18px',
                  borderRadius: 8,
                  border: a.primary
                    ? 'none'
                    : '1px solid var(--color-border, rgba(255,255,255,0.15))',
                  background: a.primary ? 'var(--color-primary, #7C3AED)' : 'transparent',
                  color: a.primary ? '#fff' : 'var(--color-text-primary, #fff)',
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: 'pointer',
                }}
              >
                {a.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
